import { cn } from '@/nucleo/utilitarios';

interface TypeScaleItem {
  name: string;
  className: string;
  sizePx: string;
  weight: string;
  sample?: string;
}

interface TypeScaleProps {
  items: TypeScaleItem[];
  fontFamily?: string;
}

export function TypeScale({ items, fontFamily }: TypeScaleProps) {
  return (
    <div className="space-y-4">
      {items.map((item) => (
        <div
          key={item.name}
          className="flex flex-col gap-1 border-b border-border/50 pb-4 last:border-0 last:pb-0"
        >
          <div className="flex flex-wrap items-baseline gap-3">
            <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground min-w-[100px]">
              {item.name}
            </span>
            <span className="text-[11px] font-mono text-muted-foreground">{item.className}</span>
            <span className="text-[11px] font-mono text-muted-foreground">
              {item.sizePx} · {item.weight}
            </span>
          </div>
          <p className={cn(item.className, fontFamily === 'mono' && 'font-mono')}>
            {item.sample || 'Transporte Escolar Gratuito — Prefeitura de São Paulo'}
          </p>
        </div>
      ))}
    </div>
  );
}
